(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["coupon-cards"] && !Shopify.designMode) return;
  try {
    (function () {
    var RESET_MS = 1800;
    var RESUME_MS = 5000;

    function reduced() {
      return window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { ta.setSelectionRange(0, text.length); } catch (e) {}
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
        document.body.removeChild(ta);
        if (ok) { resolve(); } else { reject(); }
      });
    }

    function bindCopy(root) {
      var live = root.querySelector('[data-lmi-live]');
      var strips = root.querySelectorAll('[data-lmi-copy]');

      for (var i = 0; i < strips.length; i++) {
        (function (strip) {
          var label = strip.querySelector('[data-lmi-label]');
          var original = label ? label.textContent : 'COPY';

          strip.addEventListener('click', function () {
            var code = strip.getAttribute('data-code') || '';
            if (!code) { return; }

            copyText(code).then(function () {
              strip.classList.add('is-copied');
              if (label) { label.textContent = '✓ COPIED'; }
              if (live) { live.textContent = 'Code ' + code + ' copied'; }
            })['catch'](function () {
              if (label) { label.textContent = 'SELECT'; }
              if (live) { live.textContent = 'Could not copy automatically. Code is ' + code; }
            });

            if (strip.lmiTimer) { clearTimeout(strip.lmiTimer); }
            strip.lmiTimer = setTimeout(function () {
              strip.classList.remove('is-copied');
              if (label) { label.textContent = original; }
              if (live) { live.textContent = ''; }
            }, RESET_MS);
          });
        })(strips[i]);
      }
    }

    function bindCarousel(root) {
      var rail = root.querySelector('[data-lmi-rail]');
      var dotWrap = root.querySelector('[data-lmi-dots]');
      if (!rail) { return; }

      var cards = rail.children;
      /* The parent block cannot count its children in Liquid, so the
         dots are built here from the cards actually on the page. */
      var dots = [];
      if (dotWrap && cards.length > 1) {
        dotWrap.innerHTML = '';
        for (var n = 0; n < cards.length; n++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'lmi-cpn__dot';
          dot.setAttribute('data-lmi-dot', '');
          dot.setAttribute('aria-label', 'Show offer ' + (n + 1) + ' of ' + cards.length);
          dotWrap.appendChild(dot);
        }
        dots = dotWrap.querySelectorAll('[data-lmi-dot]');
      }
      var delay = parseInt(root.getAttribute('data-autoplay'), 10);
      if (isNaN(delay)) { delay = 0; }

      var timer = null;
      var resumeTimer = null;
      var paused = false;
      var onScreen = true;
      var raf = 0;

      function scrollable() {
        return rail.scrollWidth - rail.clientWidth > 4;
      }

      function offsetOf(el) {
        return el.getBoundingClientRect().left
             - rail.getBoundingClientRect().left
             + rail.scrollLeft;
      }

      /* The last card can be fully visible while scrollLeft is clamped
         short of its offset, so nearest-offset alone reports the wrong
         index at the end of the rail. Treat max scroll as the last card. */
      function atEnd() {
        return rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
      }

      function nearest() {
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var d = Math.abs(offsetOf(cards[i]) - rail.scrollLeft);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        return best;
      }

      function current() {
        if (scrollable() && atEnd()) { return cards.length - 1; }
        return nearest();
      }

      function goTo(i, smooth) {
        var el = cards[i];
        if (!el) { return; }
        var left = offsetOf(el);
        if (smooth && !reduced() && rail.scrollTo) {
          rail.scrollTo({ left: left, behavior: 'smooth' });
        } else {
          rail.scrollLeft = left;
        }
      }

      function paint() {
        raf = 0;
        var active = current();
        for (var i = 0; i < dots.length; i++) {
          if (i === active) {
            dots[i].setAttribute('aria-current', 'true');
          } else {
            dots[i].removeAttribute('aria-current');
          }
        }
      }

      function schedulePaint() {
        if (raf) { return; }
        raf = window.requestAnimationFrame
          ? window.requestAnimationFrame(paint)
          : setTimeout(paint, 60);
      }

      function syncVisibility() {
        var on = scrollable();
        if (dotWrap) { dotWrap.hidden = !on || cards.length < 2; }
        if (on) { start(); } else { stop(); }
        schedulePaint();
      }

      function tick() {
        if (paused || !onScreen || !scrollable()) { return; }
        if (atEnd()) { goTo(0, true); return; }
        goTo(Math.min(current() + 1, cards.length - 1), true);
      }

      function start() {
        stop();
        if (delay > 0 && !reduced()) { timer = setInterval(tick, delay); }
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      function pause() {
        paused = true;
        if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      }

      function resumeSoon() {
        if (resumeTimer) { clearTimeout(resumeTimer); }
        resumeTimer = setTimeout(function () { paused = false; }, RESUME_MS);
      }

      rail.addEventListener('scroll', schedulePaint, { passive: true });

      root.addEventListener('pointerenter', pause);
      root.addEventListener('pointerleave', function () { paused = false; });
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', function () { paused = false; });
      root.addEventListener('touchstart', pause, { passive: true });
      root.addEventListener('touchend', resumeSoon, { passive: true });

      for (var d = 0; d < dots.length; d++) {
        (function (index) {
          dots[index].addEventListener('click', function () {
            goTo(index, true);
            pause();
            resumeSoon();
          });
        })(d);
      }

      if (window.ResizeObserver) {
        new ResizeObserver(syncVisibility).observe(rail);
      } else {
        window.addEventListener('resize', syncVisibility);
      }

      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
        }, { threshold: 0.25 }).observe(root);
      }

      syncVisibility();
    }

    function init() {
      var roots = document.querySelectorAll('[data-lmi-coupons]');
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].getAttribute('data-lmi-ready') === '1') { continue; }
        roots[i].setAttribute('data-lmi-ready', '1');
        bindCopy(roots[i]);
        bindCarousel(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lamed-review-highlight"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lmi-review-carousel')) {
    customElements.define('lmi-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.slides = [...this.querySelectorAll('[data-review-slide]')];
        this.dots = [...this.querySelectorAll('[data-review-dot]')];
        this.pauseButton = this.querySelector('[data-review-pause]');
        this.autoPlayMs = Number(this.dataset.autoplayMs) || 5000;
        this.currentIndex = 0;
        this.manualPaused = false;
        this.querySelector('[data-review-previous]')?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.querySelector('[data-review-next]')?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.reviewDot))));
        this.pauseButton?.addEventListener('click', () => this.toggleAutoPlay());
        this.track?.addEventListener('scroll', () => this.updateFromScroll(), { passive: true });
        this.track?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
          if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
        });
        this.addEventListener('mouseenter', () => this.stopAutoPlay());
        this.addEventListener('mouseleave', () => this.startAutoPlay());
        this.addEventListener('focusin', () => this.stopAutoPlay());
        this.addEventListener('focusout', () => this.startAutoPlay());
        this.track?.addEventListener('pointerdown', () => this.stopAutoPlay(), { passive: true });
        this.track?.addEventListener('pointerup', () => this.startAutoPlay(), { passive: true });
        this.startAutoPlay();
      }
      disconnectedCallback() { this.stopAutoPlay(); }
      startAutoPlay() {
        this.stopAutoPlay();
        if (this.manualPaused) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.autoPlayTimer = window.setInterval(() => this.goTo(this.currentIndex + 1, false), this.autoPlayMs);
      }
      stopAutoPlay() {
        if (this.autoPlayTimer) window.clearInterval(this.autoPlayTimer);
      }
      toggleAutoPlay() {
        this.manualPaused = !this.manualPaused;
        if (this.pauseButton) {
          this.pauseButton.setAttribute('aria-pressed', this.manualPaused ? 'true' : 'false');
          this.pauseButton.textContent = this.manualPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        }
        if (this.manualPaused) this.stopAutoPlay();
        else this.startAutoPlay();
      }
      goTo(index, restartAutoPlay = true) {
        if (!this.track || !this.slides.length) return;
        const nextIndex = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.slides[nextIndex].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.setCurrent(nextIndex);
        if (restartAutoPlay) this.startAutoPlay();
      }
      updateFromScroll() {
        if (!this.track?.clientWidth) return;
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.setCurrent(Math.min(Math.max(index, 0), this.slides.length - 1));
      }
      setCurrent(index) {
        this.currentIndex = index;
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true'));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
